import React from "react";
import PropTypes from "prop-types";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Chart from "components/Chart/ECharts.jsx";
import GoalProgressLeaderboard from "views/Goals/GoalProgressLeaderboard.jsx";
import ReactECharts from "echarts-for-react";

import "react-circular-progressbar/dist/styles.css";
import "./TrainingPaces.css";

const dashboardStyle = {
  dashboardContainer: {
    width: "-webkit-fill-available"
  },
  ExternalDashboardContainer: {
    width: "100%"
  },
  ExternalDashboardTitle: {
    width: "100%",
    color: "#235894",
    fontSize: "large",
    paddingTop: "25px",
    paddingBottom: "25px",
    display: "none"
  },
  ExternalDashboardROW: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "warp",
    width: "100%"
  },
  ExternalDashboardChart: {
    width: "100%",
    "padding-bottom": "30px"
  },
  ExternalDashboardChartTitle: {
    padding: "15px !important",
    marginTop: "-20px !important",
    borderRadius: "3px !important",
    background: "linear-gradient(60deg, #275b95, #00acc1) !important",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 172, 193,.4) !important"
  },
  trainingWidgets: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "-webkit-fill-available"
  },
  goalProgressWidgets: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "-webkit-fill-available",
    border: "1px solid #00acc1", // Add distinct border
    borderRadius: "8px", // Add rounded corners
    padding: "10px", // Add padding inside the div
    marginBottom: "20px" // Add spacing between widgets
  },
  trainingWidget: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "-webkit-fill-available"
  },
  trainingWidgetHeader: {
    padding: "15px !important",
    marginTop: "-20px !important",
    borderRadius: "3px !important",
    background: "linear-gradient(60deg, #275b95, #00acc1) !important",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 172, 193,.4) !important"
  },
  trainingWidgetTitle: {
    width: "100%",
    fontSize: "large"
  },
  performanceGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  performanceMetricCard: {
    border: "1px solid #d7e6ff",
    background: "#f5f9ff",
    borderRadius: "10px",
    padding: "12px"
  },
  performanceMetricLabel: {
    fontSize: "12px",
    color: "#5a6a7f",
    marginBottom: "4px",
    textTransform: "uppercase"
  },
  performanceMetricValue: {
    fontSize: "22px",
    color: "#1b2a41",
    fontWeight: 700
  },
  predictionTable: {
    width: "100%",
    borderCollapse: "collapse"
  },
  predictionTh: {
    textAlign: "left",
    borderBottom: "1px solid #d9e2ef",
    padding: "8px",
    color: "#5a6a7f",
    fontSize: "12px",
    textTransform: "uppercase"
  },
  predictionTd: {
    borderBottom: "1px solid #eef3fb",
    padding: "8px",
    color: "#2b3c4d"
  },
  performanceHeaderRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%"
  },
  smallActionButton: {
    padding: "3px 10px",
    minWidth: "auto",
    fontSize: "11px"
  }
};

class SupersetDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderExternalDashboard() {
    const { classes, widgets } = this.props;
    const widgetsList = widgets || [];
    let dashboardWidget = widgetsList.find(
      widgetData =>
        widgetData.widget &&
        widgetData.widget.source === "superset" &&
        widgetData.widget_data
    );

    if (dashboardWidget == null) return null;

    let dashboardWidgetData = dashboardWidget.widget_data;

    return (
      <div className={classes.ExternalDashboardContainer}>
        <div className={classes.ExternalDashboardTitle}>
          {dashboardWidgetData.title}
        </div>
        {this.renderDashItem(
          Object.keys(dashboardWidgetData.position).map(
            key => dashboardWidgetData.position[key]
          )
        )}
      </div>
    );
  }

  renderDashItem(items = null, parent = null) {
    if (parent === null) {
      parent = items && items.find(item => item.type === "ROOT");
    } else {
      parent = items && items.find(item => item.id === parent);
    }

    if (parent === null) return null;

    let children = parent.children;

    return (
      <div
        key={`${parent.id}-${parent.type}`}
        className={`ExternalDashboard${parent.type}`}
      >
        {parent.type === "CHART" && this.renderExternalChart(parent)}
        {children &&
          children.map(childItem => {
            return this.renderDashItem(items, childItem);
          })}
      </div>
    );
  }

  renderExternalChart(chartPositionData) {
    const { classes } = this.props;
    const { widgets } = this.props;
    const dashboardWidget =
      widgets &&
      widgets.find(
        widgetData =>
          widgetData.widget &&
          widgetData.widget_data &&
          widgetData.widget.source === "superset"
      );
    const chartData =
      dashboardWidget.widget_data.charts &&
      dashboardWidget.widget_data.charts.find(chart =>
        chartPositionData.meta.sliceName.includes(chart.name)
      );
    if (
      chartData == null ||
      chartData.data == null ||
      chartData.data.colnames == null ||
      chartData.data.colnames.length < 1
    ) {
      return null;
    }

    if (chartData.data.data == null || chartData.data.data.length < 1) {
      return null;
    }

    return (
      <Card
        key={`${chartPositionData.meta.chartId}`}
        className={classes.ExternalDashboardChart}
      >
        <CardHeader className={classes.ExternalDashboardChartTitle} stats>
          {chartData.name}
        </CardHeader>
        <CardBody>
          <Chart type="chart" chartConfig={chartData} />
        </CardBody>
      </Card>
    );
  }

  renderTrainingPaces = metadata => {
    const { other_data } = metadata;
    const vdotTrainingPaces = other_data && other_data.vdotTrainingPaces;

    if (!vdotTrainingPaces || Object.keys(vdotTrainingPaces).length === 0) {
      return <div>No training paces available</div>;
    }

    const paceColors = {
      easy: "#a5d6a7", // Light Green
      marathon: "#90caf9", // Light Blue
      threshold: "#ffcc80", // Light Orange
      interval: "#ef9a9a", // Light Red
      repetition: "#ce93d8" // Light Purple
    };

    const toTitleCase = str =>
      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

    const trainingTypes = Object.keys(vdotTrainingPaces);
    const trainingPaces = trainingTypes.map(type => {
      const pace = vdotTrainingPaces[type];
      // Convert pace from min:seconds/km to km/h
      if (typeof pace === "string") {
        const [minutes, seconds] = pace.split(":").map(Number);
        const totalSeconds = minutes * 60 + seconds;
        return { minutes, seconds, totalSeconds };
      }
      if (typeof pace === "number") {
        const totalSeconds = 3600 / pace; // Convert km/h to min:seconds/km
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = Math.round(totalSeconds % 60);
        return { minutes, seconds, totalSeconds };
      }
      return { minutes: 0, seconds: 0, totalSeconds: 0 }; // Fallback for invalid values
    });

    const equalWidthValue = 1; // Assign the same value to all sections for equal width

    const barChartOption = {
      grid: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        containLabel: false
      },
      xAxis: {
        type: "value",
        show: false
      },
      yAxis: {
        type: "category",
        data: [""], // Single bar
        show: false
      },
      series: trainingTypes.map((type, index) => ({
        name: type,
        type: "bar",
        stack: "total", // Stack all sections into one bar
        data: [equalWidthValue], // Use the same value for equal width
        itemStyle: {
          color: paceColors[type] || "#f5f5f5"
        },
        label: {
          show: true,
          position: "inside",
          formatter: () =>
            `${toTitleCase(type)}: ${trainingPaces[index].minutes}:${String(
              trainingPaces[index].seconds
            ).padStart(2, "0")} min/km`,
          color: "#000",
          fontSize: 12
        }
      })),
      tooltip: {
        trigger: "item",
        formatter: params => {
          const pace = trainingPaces[params.dataIndex];
          return `${toTitleCase(params.seriesName)}: ${pace.minutes}:${String(
            pace.seconds
          ).padStart(2, "0")} min/km`;
        }
      }
    };

    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <div
          style={{ marginBottom: "10px", fontSize: "18px", fontWeight: "bold" }}
        >
          <span role="img" aria-label="running" style={{ marginRight: "5px" }}>
            🏃
          </span>
          Your Training Paces
        </div>
        <div className="chart-container">
          <ReactECharts option={barChartOption} style={{ height: "100%" }} />
        </div>
        <div className="table-container" style={{ display: "none" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "10px"
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    textAlign: "left",
                    padding: "8px",
                    borderBottom: "2px solid #ddd"
                  }}
                >
                  Training Type
                </th>
                <th
                  style={{
                    textAlign: "left",
                    padding: "8px",
                    borderBottom: "2px solid #ddd"
                  }}
                >
                  Pace
                </th>
              </tr>
            </thead>
            <tbody>
              {trainingTypes.map((type, index) => (
                <tr key={type}>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: paceColors[type] || "#f5f5f5",
                      color: "#000",
                      fontWeight: "bold"
                    }}
                  >
                    {toTitleCase(type)}
                  </td>
                  <td
                    style={{
                      padding: "8px",
                      backgroundColor: paceColors[type] || "#f5f5f5",
                      color: "#000",
                      borderBottom: "1px solid #ddd",
                      fontWeight: "bold"
                    }}
                  >
                    {trainingPaces[index].minutes}:
                    {String(trainingPaces[index].seconds).padStart(2, "0")}{" "}
                    min/km
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderHealthMetrics() {
    const { classes, widgets } = this.props;
    const widgetsList = widgets || [];
    let trainingWidgets = widgetsList.filter(
      widgetData =>
        widgetData.widget &&
        widgetData.widget.source === "user_health_metrics" &&
        widgetData.widget.metadata &&
        widgetData.widget.metadata.active === true
    );
    if (trainingWidgets && trainingWidgets.length === 0) return null;

    return (
      trainingWidgets && (
        <div className={classes.trainingWidgets}>
          {trainingWidgets.map((trainingWidget, idx) => {
            const { training_progress } = trainingWidget.widget.metadata;
            const { other_data } = training_progress || {};
            const weeklyTrainingLoad =
              other_data && other_data.ctl_last_7_days
                ? other_data.ctl_last_7_days.toFixed(0)
                : 0;
            const monthlyTrainingLoad =
              other_data && other_data.ctl_last_28_days
                ? other_data.ctl_last_28_days.toFixed(0)
                : 0;
            const weeklyTrainingLoadRate = (
              (weeklyTrainingLoad / monthlyTrainingLoad) *
              100
            ).toFixed(0);
            const weeklyTrainingCompleteness =
              training_progress && training_progress.score
                ? (
                    (training_progress.score * 100) /
                    (training_progress.score_target || training_progress.score)
                  ).toFixed(0)
                : 0;

            const loadGaugeOption = {
              series: [
                {
                  type: "gauge",
                  progress: {
                    show: true,
                    width: 10
                  },
                  axisLine: {
                    lineStyle: {
                      width: 10
                    }
                  },
                  pointer: {
                    width: 5
                  },
                  detail: {
                    valueAnimation: true,
                    formatter: "{value}",
                    fontSize: 16
                  },
                  data: [
                    {
                      value: weeklyTrainingLoad,
                      name: "Weekly Load"
                    }
                  ]
                }
              ]
            };

            const loadRateGaugeOption = {
              series: [
                {
                  type: "gauge",
                  progress: {
                    show: true,
                    width: 10
                  },
                  axisLine: {
                    lineStyle: {
                      width: 10
                    }
                  },
                  pointer: {
                    width: 5
                  },
                  detail: {
                    valueAnimation: true,
                    formatter: "{value}%",
                    fontSize: 16
                  },
                  data: [
                    {
                      value: weeklyTrainingLoadRate,
                      name: "Load Rate"
                    }
                  ]
                }
              ]
            };

            const completenessGaugeOption = {
              series: [
                {
                  type: "gauge",
                  progress: {
                    show: true,
                    width: 10
                  },
                  axisLine: {
                    lineStyle: {
                      width: 10
                    }
                  },
                  pointer: {
                    width: 5
                  },
                  detail: {
                    valueAnimation: true,
                    formatter: "{value}%",
                    fontSize: 16
                  },
                  data: [
                    {
                      value: weeklyTrainingCompleteness,
                      name: "Progress current week"
                    }
                  ]
                }
              ]
            };

            return (
              <React.Fragment key={idx}>
                <Card className={classes.trainingWidget}>
                  <CardHeader className={classes.trainingWidgetHeader} stats>
                    Training Status
                  </CardHeader>
                  <CardBody>
                    {this.renderTrainingPaces(trainingWidget.widget.metadata)}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "20px",
                        marginBottom: "20px"
                      }}
                    >
                      <div style={{ width: "300px", height: "300px" }}>
                        <ReactECharts option={loadGaugeOption} />
                      </div>
                      <div style={{ width: "300px", height: "300px" }}>
                        <ReactECharts option={loadRateGaugeOption} />
                      </div>
                      <div style={{ width: "300px", height: "300px" }}>
                        <ReactECharts option={completenessGaugeOption} />
                      </div>
                    </div>
                  </CardBody>
                </Card>
                {this.renderPerformanceWidget(trainingWidget.widget.metadata)}
              </React.Fragment>
            );
          })}
        </div>
      )
    );
  }

  renderPerformanceWidget = metadata => {
    const { classes } = this.props;
    const otherData = (metadata && metadata.other_data) || {};
    const racePredictions = otherData.racePredictions || {};
    const lactateThresholdPace = otherData.lactateThresholdPace;
    const marathonShape = otherData.marathonShape;
    const predictionRows = [
      ["5K", racePredictions["5k"]],
      ["10K", racePredictions["10k"]],
      ["Half-Marathon", racePredictions.half_marathon],
      ["Marathon", racePredictions.marathon]
    ];

    return (
      <Card className={classes.trainingWidget}>
        <CardHeader className={classes.trainingWidgetHeader} stats>
          <div className={classes.performanceHeaderRow}>
            <span>Performance Metrics</span>
            <Button
              color="warning"
              simple
              size="sm"
              className={classes.smallActionButton}
              onClick={() =>
                this.props.onForcePerformanceMetrics &&
                this.props.onForcePerformanceMetrics()
              }
              disabled={this.props.widgetsLoading}
            >
              Recalculate Marathon Shape
            </Button>
          </div>
        </CardHeader>
        <CardBody>
          <div className={classes.performanceGrid}>
            <div className={classes.performanceMetricCard}>
              <div className={classes.performanceMetricLabel}>VO2 Max</div>
              <div className={classes.performanceMetricValue}>
                {metadata && metadata.vo2_max != null
                  ? metadata.vo2_max.toFixed(1)
                  : "--"}
              </div>
            </div>
            <div className={classes.performanceMetricCard}>
              <div className={classes.performanceMetricLabel}>
                Lactate Threshold
              </div>
              <div className={classes.performanceMetricValue}>
                {lactateThresholdPace ||
                  (metadata && metadata.lactate_threshold != null
                    ? `${metadata.lactate_threshold.toFixed(2)} min/km`
                    : "--")}
              </div>
            </div>
            <div className={classes.performanceMetricCard}>
              <div className={classes.performanceMetricLabel}>
                Marathon Shape
              </div>
              <div className={classes.performanceMetricValue}>
                {marathonShape && marathonShape.value != null
                  ? `${marathonShape.value.toFixed(1)}%`
                  : "--"}
              </div>
            </div>
          </div>

          <table className={classes.predictionTable}>
            <thead>
              <tr>
                <th className={classes.predictionTh}>Distance</th>
                <th className={classes.predictionTh}>Predicted Time</th>
                <th className={classes.predictionTh}>Pace</th>
              </tr>
            </thead>
            <tbody>
              {predictionRows.map(([label, prediction]) => (
                <tr key={label}>
                  <td className={classes.predictionTd}>{label}</td>
                  <td className={classes.predictionTd}>
                    {prediction && prediction.predicted_time
                      ? prediction.predicted_time
                      : "--"}
                  </td>
                  <td className={classes.predictionTd}>
                    {prediction && prediction.pace_min_per_km
                      ? `${prediction.pace_min_per_km}/km`
                      : "--"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
      </Card>
    );
  };

  renderLeaderboard() {
    const { classes, widgets } = this.props;
    const widgetsList = widgets || [];
    let leaderboardWidget = widgetsList.find(
      widgetData =>
        widgetData.widget &&
        widgetData.widget.name === "user_goals_progress" &&
        widgetData.widget.source === "other" &&
        widgetData.widget.metadata &&
        widgetData.widget.metadata.active === true
    );
    if (!leaderboardWidget) return null;
    const goalIds = leaderboardWidget.widget.metadata.goal_ids;
    const goalsData = leaderboardWidget.widget.metadata.goal_progress_data;
    if (!goalIds || goalIds.length === 0) return null;
    // show a divider here with message user goals progress
    return (
      <Card className={classes.trainingWidget}>
        <CardHeader className={classes.trainingWidgetHeader} stats>
          <span>Group Goals</span>
        </CardHeader>
        <CardBody>
          {goalIds.map((goalId, index) => (
            <div key={index} className={classes.goalProgressWidgets}>
              <GoalProgressLeaderboard
                axios={this.props.axios}
                goalId={goalId}
                progressData={goalsData.find(data => data.goal.id === goalId)}
              />
            </div>
          ))}
        </CardBody>
      </Card>
    );
  }

  render() {
    const { classes, widgetsLoading, widgetsError } = this.props;

    if (widgetsLoading) {
      return <div>Loading dashboard...</div>;
    }

    if (widgetsError) {
      return <div>Error loading dashboard</div>;
    }

    return (
      <div className={classes.dashboardContainer}>
        {this.renderHealthMetrics()}
        {this.renderLeaderboard()}
        {this.renderExternalDashboard()}
      </div>
    );
  }
}

SupersetDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  userId: PropTypes.number,
  history: PropTypes.any,
  widgets: PropTypes.array,
  widgetsLoading: PropTypes.bool,
  widgetsError: PropTypes.bool,
  axios: PropTypes.func,
  onForcePerformanceMetrics: PropTypes.func
};

export default withStyles(dashboardStyle)(SupersetDashboard);
